import { render, staticRenderFns } from "./CustomerSummaryStandard.vue?vue&type=template&id=3ceb9a9a"
import script from "./CustomerSummaryStandard.vue?vue&type=script&lang=ts"
export * from "./CustomerSummaryStandard.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSummaryStandard.vue?vue&type=style&index=0&id=3ceb9a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports